import React from 'react';
import NavBarView from './screens/NavBarView';
import axios from "axios"

axios.defaults.headers.common['X-CSRF-Token'] = document.querySelectorAll('meta[name="csrf-token"]')[0]['content'];

export default props => (
  <NavBarView {...props} />
);



// WEBPACK FOOTER //
// ./app/javascript/components/customer/brief/navbar.js